/* eslint-disable react/display-name */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { forwardRef, useCallback, useEffect } from "react";
import { SketchField, Tools } from "@/@corefabriccanvas";
import { BlankPage } from "@/database/userPageDatabaseService";
import {
  DisplayTypes,
  EraserShortCuts,
  PageCanvasModel,
  PageIcon,
  PageIconType,
  PageItemCanvasModel,
  PageNavigationDirection,
  SubToolType,
  UserContentType,
} from "@/types";
import { useDrawingContext } from "@/contexts/DrawingContext";
import { formatDateToString, openWebSide, uuidv4 } from "@/utility/utils";
import { useModal } from "@/contexts/ModalContext";
import {
  deleteUserNote,
  saveUserNote,
  updateNotePosition,
  UserNote,
} from "@/database/userNoteDatabaseService";
import "./paperType.scss";
import AddNote from "./UserNote/AddNote";
import {
  PageCanvasService,
  removeUserDrawing,
  saveUserPageDrawings,
} from "@/database/smartBookModelService";
import ActivityPopup from "./Activity";
// import {
//   saveUserPageDrawings,
// } from 'renderer/data/ionicStorage';

interface SketchFieldProps {
  bookId: number;
  userId: string;
  width: number;
  height: number;
  displayType: DisplayTypes;
  pageItemPosition: "left" | "right" | "center";
  currentTool: Tools;
  previousTool: Tools;
  activeSubTool: SubToolType | undefined;
  updateActiveSubTool: (type: SubToolType | undefined) => void;
  currentPage: PageCanvasModel;
  currentBlankPage: BlankPage;
  blankPages: BlankPage[];
  ref: any;
  eraseThickness: number;
  eraserShortCut: EraserShortCuts | undefined;
  hideIcons?: boolean;
  selectedColor: string;
  thickness: number;
  dispatch: (action: any) => void;
  setTool: (tool: Tools) => void;
  setDisplayType: (type: DisplayTypes) => void;
  setCurrentBlankPage: (blankPage: BlankPage) => void;
  currentPageItem: PageItemCanvasModel | null;
  setCurrentPageItem: (pageItem: PageItemCanvasModel | null) => void;
  handlePageChange: (direction: PageNavigationDirection) => void;
}

const Sketch = forwardRef<any, SketchFieldProps>((props, ref) => {
  const {
    bookId,
    userId,
    width,
    height,
    displayType,
    currentTool,
    previousTool,
    activeSubTool,
    pageItemPosition,
    updateActiveSubTool,
    currentPage,
    currentBlankPage,
    eraseThickness,
    eraserShortCut,
    hideIcons,
    selectedColor,
    thickness,
    setTool,
    setDisplayType,
    handlePageChange,
    dispatch,
    setCurrentBlankPage,
    currentPageItem,
    setCurrentPageItem,
  } = props;

  const { openModal, closeModal } = useModal();
  const { isNoteAreaActive, addingNoteType, deactivateNoteArea } =
    useDrawingContext();

  const onImageCrop = (e: any) => {
    setTool(Tools.Pencil);

    const newPage = {
      id: null,
      userId: userId,
      json: "",
      paperType: "",
      bookId: bookId,
      dataUrl: "",
      title: "",
      isSaved: false,
      createdDate: formatDateToString(new Date()),
      cropArea: { ...e, pageImage: currentPage.pageImage },
    };
    dispatch(setCurrentBlankPage(newPage));
    dispatch(setDisplayType(DisplayTypes.BlankPage));
  };

  const onIconClick = async (pageIcon: PageIcon) => {
    if (
      pageIcon.type === PageIconType.Question ||
      pageIcon.type === PageIconType.Interacts
    ) {
      const pageItem = await PageCanvasService.getPageItemFromId(
        bookId,
        width,
        height,
        currentPage,
        Number(pageIcon.id)
      );
      if (pageItem) {
        dispatch(setCurrentPageItem(pageItem));
      }
    } else if (
      pageIcon.type === PageIconType.Sound ||
      pageIcon.type === PageIconType.Video ||
      pageIcon.type === PageIconType.Image ||
      pageIcon.type === PageIconType.Drawing ||
      pageIcon.type === PageIconType.TextNote
    ) {
      openModal(
        "activity",
        "",
        "withoutOverlay",
        <ActivityPopup activity={pageIcon} deleteNote={deleteNote} />
      );
    } else if (pageIcon.type === PageIconType.Url) {
      openWebSide(pageIcon.filePath || pageIcon.correctAnswer || "");
    } else if (pageIcon.type === PageIconType.File) {
      // window.electron.openFile(pageIcon.filePath || '');
    }
  };
  /** Note Methods Start */
  const SaveNote = useCallback(
    async (content: string, x: number, y: number) => {
      const note: UserNote = {
        id: uuidv4(),
        userId,
        noteType: addingNoteType,
        content: content,
        bookId,
        pageId: currentPage.pageId,
        x,
        y,
        canvasWidth: width,
        canvasHeight: height,
      };
      const pageIcon = await saveUserNote(note);
      if (ref && "current" in ref) {
        ref.current.addNoteIcon(pageIcon);
      }
      closeModal();
    },
    [
      addingNoteType,
      bookId,
      closeModal,
      currentPage.pageId,
      height,
      ref,
      userId,
      width,
    ]
  );

  const deleteNote = async (noteId: string) => {
    await deleteUserNote(noteId);
    if (ref && "current" in ref) {
      ref.current.removeNoteIcon(noteId);
    }
    closeModal();
  };
  const onNoteAreaSelected = async (e: any) => {
    if (
      addingNoteType === UserContentType.Text ||
      addingNoteType === UserContentType.Link ||
      addingNoteType === UserContentType.Drawing
    ) {
      openModal(
        addingNoteType,
        "İçerik Ekle",
        "withOverlay",
        <AddNote
          addingNoteType={addingNoteType}
          saveNote={(content: string) => SaveNote(content, e.x, e.y)}
        />
      );
    } else {
      // const fileExtensions = getExtensionsForContentType(addingNoteType);
      // const files: string =
      //   await window.electron.openFileDialog(fileExtensions);
      // if (files && files.length > 0) {
      //   const filePath = await window.file.copyFile(
      //     `${bookId}/userContents`,
      //     files[0],
      //   );
      //   SaveNote(filePath, e.x, e.y);
      // }
    }
    setTool(previousTool);
    deactivateNoteArea();
  };

  useEffect(() => {
    if (isNoteAreaActive) {
      setTool(Tools.Pan);
    }
  }, [isNoteAreaActive]);
  /** Note Methods End */
  const onMouseDown = () => {
    if (activeSubTool) {
      updateActiveSubTool(undefined);
    }
  };

  useEffect(() => {}, [isNoteAreaActive]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const saveData = async () => {
    setTimeout(() => {
      if (
        ref &&
        ref &&
        "current" in ref &&
        (displayType === DisplayTypes.Page ||
          displayType === DisplayTypes.PageItem)
      ) {
        if (
          displayType === DisplayTypes.PageItem &&
          currentPageItem?.isExercise
        ) {
          return;
        }
        if (ref.current) {
          const json = JSON.stringify(ref.current.toJSON());
          const savedData = JSON.parse(json);
          delete savedData.background;
          delete savedData.backgroundImage;
          const objects = savedData.objects.filter(
            (x: any) =>
              x.type !== "image" && !x.clearOnReset && x.type !== "i-text"
          );
          savedData.objects = objects;
          if (objects.length > 0) {
            saveUserPageDrawings(
              bookId,
              displayType,
              displayType === DisplayTypes.Page
                ? currentPage.pageId
                : currentPageItem?.id || 0,
              JSON.stringify(savedData)
            );
          } else {
            removeUserDrawing(
              bookId,
              displayType,
              displayType === DisplayTypes.Page
                ? currentPage.pageId
                : currentPageItem?.id || 0
            );
          }
        }
      }
    }, 50);
  };

  const _onSketchChange = () => {
    saveData();
  };
  return (
    <SketchField
      ref={ref}
      userId={userId}
      bookId={bookId}
      tool={currentTool}
      isNoteAreaActive={isNoteAreaActive}
      hideIcons={hideIcons}
      onMouseDown={onMouseDown}
      onNoteAreaSelected={onNoteAreaSelected}
      onIconClick={onIconClick}
      onZoomChange={(e: number) => console.log(e)}
      eraserShortCut={eraserShortCut}
      handlePageChange={handlePageChange}
      onNotePositionChange={({
        id,
        x,
        y,
      }: {
        id: string;
        x: number;
        y: number;
      }) => {
        updateNotePosition(id, x, y, width, height);
      }}
      displayType={displayType}
      pageItemPosition={pageItemPosition}
      height={height}
      width={width}
      onImageCrop={onImageCrop}
      onSetTool={setTool}
      currentBlankPage={currentBlankPage}
      currentPage={currentPage}
      currentPageItem={currentPageItem}
      lineColor={selectedColor}
      lineWidth={currentTool === Tools.Eraser ? eraseThickness : thickness}
      onChange={_onSketchChange}
      className={
        displayType === DisplayTypes.BlankPage
          ? currentBlankPage?.paperType
          : ""
      }
    />
  );
});

export default Sketch;
